import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AddShoplistProductComponent } from './components/add-shoplist-product/add-shoplist-product.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { TemplateDirective } from './directives/template.directive';
import { DropdownItemComponent } from './components/dropdown/dropdown-item/dropdown-item.component';
import { DropdownComponent } from './components/dropdown/dropdown/dropdown.component';
import { EditBundleItemComponent } from './components/edit-bundle-item/edit-bundle-item.component';
import {
  EditBundleMultiVariantChildComponent
} from './components/edit-bundle-multi-variant-child/edit-bundle-multi-variant-child.component';
import { EditBundleMultiVariantComponent } from './components/edit-bundle-multi-variant/edit-bundle-multi-variant.component';
import {
  EditBundleSingleVariantComponent
} from './components/edit-bundle-single-variant/edit-bundle-single-variant.component';
import { EditBundleSummaryComponent } from './components/edit-bundle-summary/edit-bundle-summary.component';
import { EmailComponent } from './components/email/email.component';
import { GuaranteeComponent } from './components/guarantee/guarantee.component';
import { ImageLoaderComponent } from './components/image-loader/image-loader.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ProductSearchComponent } from './components/product-search/product-search.component';
import { ShareItemComponent } from './components/share-item/share-item.component';
import { SharebarComponent } from './components/sharebar/sharebar.component';
import { ShopListFormComponent } from './components/shop-list-form/shop-list-form.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SuggestedProductListComponent } from './components/suggested-product-list/suggested-product-list.component';
import { SuggestedProductComponent } from './components/suggested-product/suggested-product.component';
import { VariantProductComponent } from './components/variant-product/variant-product.component';
import { InfiniteScrollerDirective } from './directives/infinite-scroller/infinite-scroller.directive';
import { RoleDirective } from './directives/role.directive';
import { OwlCarouselConfig } from './models/owl-carousel-config.modal';
import { SharedConfig } from './models/shared-config.model';
import { owlCarouselConfig } from './owl-carousel.config';
import { PriceFormatterPipe } from './pipes/price-formatter.pipe';
import { sharedConfig } from './shared.config';
import { ContactFooterComponent } from './components/contact-footer/contact-footer.component';
import { MobHeaderComponent } from './components/mob-header/mob-header.component';
import { HeaderUserInfoSidebarComponent } from './components/header-user-info-sidebar/header-user-info-sidebar.component';


@NgModule({
  declarations: [
    RoleDirective,
    GuaranteeComponent,
    LoaderComponent,
    AddShoplistProductComponent,
    ProductSearchComponent,
    SuggestedProductListComponent,
    SuggestedProductComponent,
    ProductSearchComponent,
    PriceFormatterPipe,
    SpinnerComponent,
    ShopListFormComponent,
    ImageLoaderComponent,
    SharebarComponent,
    EmailComponent,
    VariantProductComponent,
    BreadcrumbComponent,
    EditBundleItemComponent,
    EditBundleMultiVariantComponent,
    EditBundleSingleVariantComponent,
    EditBundleSummaryComponent,
    EditBundleMultiVariantChildComponent,
    ShareItemComponent,
    InfiniteScrollerDirective,
    TemplateDirective,
    DropdownItemComponent,
    DropdownComponent,
    ContactFooterComponent,
    MobHeaderComponent,
    HeaderUserInfoSidebarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild()
  ],
  exports: [
    CommonModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    RoleDirective,
    InfiniteScrollerDirective,
    GuaranteeComponent,
    LoaderComponent,
    AddShoplistProductComponent,
    PriceFormatterPipe,
    SpinnerComponent,
    ShopListFormComponent,
    ImageLoaderComponent,
    SharebarComponent,
    EmailComponent,
    BreadcrumbComponent,
    EditBundleItemComponent,
    EditBundleMultiVariantComponent,
    EditBundleSingleVariantComponent,
    EditBundleSummaryComponent,
    EditBundleMultiVariantChildComponent,
    ShareItemComponent,
    TemplateDirective,
    DropdownItemComponent,
    DropdownComponent,
    ContactFooterComponent,
    MobHeaderComponent,
    HeaderUserInfoSidebarComponent
  ]
})
export class SharedModule {
  static forRoot(config: SharedConfig, carouselConfig: OwlCarouselConfig): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [{ provide: sharedConfig, useValue: config }, { provide: owlCarouselConfig, useValue: carouselConfig }]
    };
  }
}
